import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { reduxForm, InjectedFormProps} from 'redux-form';
import { toast } from 'react-toastify';
import LoaderButton from '../../../shared/components/Button/LoaderButton';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from '../../../translations/connectedIntlProvider';
import modelEnum from '../../../constants/model.enum';

interface IProps {
    submitHandler: (data: any) => void;
    onModalClosed: () => void;
    columnList: Array<any>;
    from:string;
    model?:string;
    isLoading?:boolean;
    checkChildElement: (data: any) => void;
}

const AddSensorColumnForm: React.FC<InjectedFormProps<any, IProps> & IProps> = (props: any) => {
    const [showHideColumns, setshowHideColumns] = useState<Array<any>>([]);


    const getModePrefix = () =>{
        switch(props.model.toLowerCase()){
            case modelEnum.AQS2.toLowerCase():
                return modelEnum.AQS2.toLowerCase(); 
            case modelEnum.FDS2.toLowerCase():
               return modelEnum.FDS2.toLowerCase();
            case modelEnum.TIS.toLowerCase():
                return modelEnum.TIS.toLowerCase();
            case modelEnum.PS.toLowerCase():
                return modelEnum.PS.toLowerCase();
            case modelEnum.AQS3.toLowerCase():
                return modelEnum.AQS3.toLowerCase();
            default: 
                return '';
        }
    }
    let modePrefix = getModePrefix();
    useEffect(() => {
      setshowHideColumns(props.columnList);
    }, [props.columnList]);
    
    const handleChange = (e:any) => {
      const { value,id, checked } = e.target;
      props.checkChildElement(e)
      if (id === "0") {
        let tempshowHideColumns = showHideColumns.map((showHideColumn) => {
          return { ...showHideColumn, isChecked: checked };
        });
        setshowHideColumns(tempshowHideColumns);
      } else {
        let tempshowHideColumns = showHideColumns.map((showHideColumn) =>
          showHideColumn.value === value ? { ...showHideColumn, isChecked: checked } : showHideColumn
        );
        setshowHideColumns(tempshowHideColumns);
      }
    };
    return (
        <Modal className="add-user-modal device-pop-up large-popup" show={true} centered onHide={props.onModalClosed}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {
                        props.from === 'SensorData' ?
                        <FormattedMessage id='Show_Hide_Column' /> :
                        <FormattedMessage id='Show_Hide_Chart' />
                    }
                </Modal.Title>
                {/*   {props.getSensorLoading ? <PageLoader /> : null} */}
            </Modal.Header>

            <form onSubmit={props.handleSubmit((values: any) => props.submitHandler(values))} noValidate>
            <Modal.Body>
                <div className="row">
                    {
                        props.columnList.map((item: any, index: any) => {
                            return (
                               
                                    <div className={item.value==="SelectAll" ? "col-md-12 checkbox border-bottom" : "col-md-6 checkbox"}  key={index}>
                                        <div className="checkbox-area my-1">
                                            <label>
                                                <input id={item.id} onChange={handleChange}
                                                    type="checkbox" value={item.value} checked={(item.id===0)?
                                                    (!showHideColumns.some((showHideColumn) => showHideColumn?.isChecked !== true)):
                                                    (showHideColumns[index]?.isChecked || false)}/>
                                                <span className="cr">
                                                    <i className="cr-icon fas fa-check"></i>
                                                </span>
                                            </label>
                                            <p><FormattedMessage id={!(item.id === 0 || item.id === 1 ) ? modePrefix+item.value : item.value} /></p>
                                    </div>
                                    </div>
                                
                            )
                        })
                    }
                </div>

                </Modal.Body>

                <div className="modal-footer">
                    <div className="form-group row tab-action">
                        <div className="col-12 px-0">
                            <Button variant="primary" onClick={props.onModalClosed}><FormattedMessage id='Button_Cancel' /></Button>
                            <LoaderButton type="submit" isLoading={props.isLoading} text="Button_Save" />
                        </div>
                    </div>
                </div>

            </form>

        </Modal>
    )
}


const form = reduxForm<any, IProps>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    form: 'AddSensorColumnForm',
    enableReinitialize: true,
    onSubmitFail: (errors: any) => {
        toast.error(formatMessage('Validation_Correct_error'));
    }
})(AddSensorColumnForm);


export default (form);
